/* global axios */
import ApiClient from './ApiClient';

class TargetsAPI extends ApiClient {
  constructor(resource) {
    super(resource, { accountScoped: true, apiVersion: 'v2' });
  }

  index(params = {}) {
    return axios.get(this.url, { params });
  }

  bulkApply(data) {
    return axios.post(`${this.url}/bulk_apply`, data);
  }
}

export const agentTargetsAPI = new TargetsAPI('agent_targets');
export const teamTargetsAPI = new TargetsAPI('team_targets');

export default {
  agentTargets: agentTargetsAPI,
  teamTargets: teamTargetsAPI,
};
